import React from 'react';
import { Box } from '@mui/material';
import clsx from 'clsx';
import { Link } from 'react-router-dom';

import styles from './index.module.scss';

type IProps = {
  Icon: any,
  text: string,
  link?: string,
  active?: boolean,
  onClick?: () => void
};

const MenuItem = (props: IProps) => {
  const { Icon, text, link, active = false, onClick = () => null } = props;


  const showItem = (
    <Box onClick={onClick} className={clsx(styles.menuItem, { [styles.active]: active })}>
      <Icon className={styles.icon} />
      <span className={styles.text}>{text}</span>
    </Box>
  );

  if (link) {
    return (
      <Link to={link}>
        {showItem}
      </Link>
    )
  }

  return showItem;
};

export default MenuItem;